import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';

import {doBookMark, getMagazineCollectionRecommend} from '@/services/magazine';
import {addComma} from '@/utils';
import {user} from '@/store';

import styles from './styles.module.scss';

// api 확인후 타입 수정 예정
interface Topic {
  created: string;
  explain: string;
  id: number;
  imageUrl: string;
  magazines: CollectionListItem[];
  length: number;
  priority: number;
  subtitle: string;
  title: string;
  type: string;
}

const KnewTopicCollection = () => {
  const [topic, setTopic] = useState<Topic>();
  const [isBookmark, setIsBookMark] = useState<boolean[]>();
  const accessToken = useRecoilValue(user);
  const navigator = useNavigate();

  const doLike = async (
    $event: React.MouseEvent<HTMLSpanElement>,
    item: CollectionListItem,
    index: number,
  ) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (!accessToken) {
      navigator('/login', {
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      });
      return;
    }
    if (!!isBookmark && isBookmark?.length > 0) {
      await doBookMark(item.id, !isBookmark?.[index], accessToken);
      const list = isBookmark.map((item, i) => (index === i ? !item : item));
      setIsBookMark(list);
    }
  };

  const init = async () => {
    const {data} = await getMagazineCollectionRecommend(accessToken);
    setTopic(data?.[0]);
    const list = data?.[0].magazines.map((item: CollectionListItem) => {
      return item.isBookmark;
    });
    setIsBookMark(list);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.img_wrapper}>
        <img src={topic?.imageUrl} />
      </div>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>{topic?.title}</div>
        {topic?.subtitle && (
          <div className={styles.subTitle}>{topic?.subtitle}</div>
        )}
      </div>
      <div className={styles.list_wrapper}>
        {topic?.magazines &&
          topic?.magazines.map((item, index) => {
            return (
              <div
                key={`magazine-item-${index}`}
                className={styles.list_item}
                onClick={() =>
                  navigator(`/popup/${item.id}`, {
                    state: {
                      prev: 'home',
                    },
                  })
                }>
                <div className={styles.imgWrapper}>
                  <img src={item.imageUrl} />
                </div>
                <div className={styles.txtWrapper}>
                  <div className={styles.collectionTitle}>{item.title}</div>
                  <div className={styles.price}>
                    {!!item.discountNumber && item.discountNumber > 0 && (
                      <span>{item.discountNumber}%</span>
                    )}
                    {addComma(Number(item.price ?? 0))}
                  </div>
                </div>
                <div className={styles.likeWrapper}>
                  <span
                    className={`${styles.likeIcon} ${
                      isBookmark?.[index] ? styles.filled : ''
                    }`}
                    onClick={($event: React.MouseEvent<HTMLSpanElement>) =>
                      doLike($event, item, index)
                    }></span>
                </div>
              </div>
            );
          })}
      </div>
      <div className={styles.btn_wrapper}>
        <button
          type="button"
          className={styles.btn}
          onClick={() => {
            navigator('/collection/list');
          }}>
          다른 컬렉션 보기
        </button>
      </div>
    </div>
  );
};

export default KnewTopicCollection;
